import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "raskKilometer" })
export class KilometerPipe implements PipeTransform {
    transform(kilometer: string | number, decimals: number): string {
        return kilometer != null ? `${parseFloat(kilometer.toString()).toFixed(decimals ?? 1)} km` : "-";
    }
}
